import React from "react";

function ToolInfo() {
  return (
    <div className="tool-info">
      <div className="tool-info-body">
        <p>The economic contributions of international students are in addition to the immeasurable
        academic and cultural value these students bring to our campuses and local communities. For a
        more detailed analysis, access NAFSA's International Student Economic Value Tool at
        <br/>&nbsp;<a href="/economicvalue">nafsa.org/economicvalue</a>.</p>
      </div>
      <div className="contact">
        <div className="contact-title">CONTACT</div>
        <div className="contact-body">
          <strong>Rachel&nbsp;Banks</strong><br/>
          <i>Senior Director, Public Policy & Legislative Strategy</i><br/>
          <a href="mailto:rachel.banks@nafsa.org">rachel.banks@nafsa.org</a>
        </div>
      </div>
    </div>
  )
}

function Disclaimer() {
  return (
    <div className="disclaimer">* Sources used in NAFSA economic analysis: U.S. Department of Education,
        U.S. Department of Commerce, and Institute of International Education for 2023-2024 Academic Year.
    </div>
  )
}

function ErrorMessage() {
  return (
    <div className="error-message">
      <div className="nafsa-logo">
        <img src={`/themes/custom/nafsa/images/nafsa_logo_isev.jpg`} alt="nafsa-logo"/>
      </div>
      <h2>Benefits from International Students</h2>
      <p>To Generate a Report per State and/or District,</p>
      <p>Go to the <a href="/policy-and-advocacy/policy-resources/nafsa-international-student-economic-value-tool-v2">International
        Student Economic Value Tool</a></p>
    </div>
  )
}

export { ToolInfo, Disclaimer, ErrorMessage }
